import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'form',
    path: 'due_date',
    viewPath: props.viewPath,
  })

  return function onChange(_, date) {
    change(date)
    props.closePopover()
  }
}
